import { SupportedLanguages } from "gql/graphql";

export const LANGUAGE_TO_PLACEHOLDER = (lang: SupportedLanguages) =>
  `placeholder ${lang}`;
